var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMenuBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.5C1.83696 4.5 1.20107 4.26295 0.732234 3.84099C0.263393 3.41903 0 2.84674 0 2.25C0 1.65326 0.263393 1.08097 0.732234 0.65901C1.20107 0.237053 1.83696 0 2.5 0C3.16304 0 3.79893 0.237053 4.26777 0.65901C4.73661 1.08097 5 1.65326 5 2.25C5 2.84674 4.73661 3.41903 4.26777 3.84099C3.79893 4.26295 3.16304 4.5 2.5 4.5ZM2.5 11.25C1.83696 11.25 1.20107 11.0129 0.732234 10.591C0.263393 10.169 0 9.59674 0 9C0 8.40326 0.263393 7.83097 0.732234 7.40901C1.20107 6.98705 1.83696 6.75 2.5 6.75C3.16304 6.75 3.79893 6.98705 4.26777 7.40901C4.73661 7.83097 5 8.40326 5 9C5 9.59674 4.73661 10.169 4.26777 10.591C3.79893 11.0129 3.16304 11.25 2.5 11.25ZM2.5 18C1.83696 18 1.20107 17.7629 0.732234 17.341C0.263393 16.919 0 16.3467 0 15.75C0 15.1533 0.263393 14.581 0.732234 14.159C1.20107 13.7371 1.83696 13.5 2.5 13.5C3.16304 13.5 3.79893 13.7371 4.26777 14.159C4.73661 14.581 5 15.1533 5 15.75C5 16.3467 4.73661 16.919 4.26777 17.341C3.79893 17.7629 3.16304 18 2.5 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMenuBlack);
export default __webpack_public_path__ + "static/media/phone_menu_black.14c39c4f01382d0228581eb5c3e2acb1.svg";
export { ForwardRef as ReactComponent };